export const ENV = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5452/api/v1',
} as const;